import {CalcInput} from "./calc-input";
import {Block, DocumentationType} from "./block";
import {CalcInputData} from "./calc-input";

export interface InstructionData {
  id: number;
  name: string;
  block: string;
  inputs: CalcInputData[];
  yes?: InstructionData[];
  no?: InstructionData[];
  complexityPreparer?: number;
  complexityReviewer1?: number;
  complexityReviewer2?: number;
  description?: string;
  documentation?: DocumentationType;
}

export class Instruction {
  constructor(
    public id: number,
    public name: string,
    public block: Block,
    public inputs: CalcInput[],
    public yes?: Instruction[],
    public no?: Instruction[],
    public complexityPreparer?: number,
    public complexityReviewer1?: number,
    public complexityReviewer2?: number,
    public description?: string,
  ) {
    if (!description) {
      this.description = block.description;
    }
  }
}
